export const C = {
  navy: '#162035',
  navyM: '#1E2D4A',
  navyL: '#EEF2F8',
  navyXL: '#F2F5FA',
  red: '#C0392B',
  redL: '#FEF2F2',
  green: '#0F6B3A',
  greenL: '#EDFAF4',
  amber: '#B45309',
  amberL: '#FFFBEB',
  teal: '#0E7490',
  tealL: '#ECFEFF',
  purple: '#6D28D9',
  purpleL: '#F5F3FF',
  orange: '#C2410C',
  orangeL: '#FFF7ED',
  ink: '#0F172A',
  grey: '#475569',
  // Texte secondaire : la teinte de la maquette V288, reference du client.
  muted: '#94A3B8',
  border: '#E2E8F0',
  warm: '#F8F7F4',
  bg: '#F1F0EC',
  white: '#FFFFFF',
};

export const DA = '#C0252B'; // accent rouge des documents

export const _h2rG = (h) => {
  h = (h || '#000').replace('#', '');
  return [
    parseInt(h.slice(0, 2), 16) || 0,
    parseInt(h.slice(2, 4), 16) || 0,
    parseInt(h.slice(4, 6), 16) || 0,
  ];
};

export const _lumG = (h) => {
  const [r, g, b] = _h2rG(h);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
};

/**
 * Encre d'un texte pose sur sa propre teinte claire : un peu plus foncee que
 * la couleur ; inchangee si la couleur n'est pas un hexadecimal a six chiffres.
 */
export const encreTeinte = (h) => (/^#[0-9A-Fa-f]{6}$/.test(h || '') ? _darkG(h, 0.12) : h);

export const _darkG = (h, f) => {
  const [r, g, b] = _h2rG(h);
  const d = (x) => Math.round(x * (1 - f));
  return '#' + [d(r), d(g), d(b)].map((x) => x.toString(16).padStart(2, '0')).join('');
};

/**
 * Couleurs d'accent des documents, inspirees des corps de metier.
 * Definies ici et non dans les constantes documentaires : le calcul de
 * contraste `docAcc` en depend, et l'inverse creerait un cycle d'imports.
 */
export const DOC_COULEURS = [
  { id: 'macon', nom: 'Maçonnerie', accent: '#C2C7CE' },
  { id: 'plomberie', nom: 'Plomberie', accent: '#A8C7E8' },
  { id: 'chauffage', nom: 'Chauffage / sanitaire', accent: '#9CC6CE' },
  { id: 'electricite', nom: 'Électricité', accent: '#EAD9A0' },
  { id: 'peinture', nom: 'Peinture', accent: '#BFD4BE' },
  { id: 'carrelage', nom: 'Carrelage', accent: '#A6DCE0' },
  { id: 'menuiserie', nom: 'Menuiserie', accent: '#D8C3A3' },
  { id: 'toiture', nom: 'Couverture / toiture', accent: '#AEB7C4' },
  { id: 'paysage', nom: 'Paysagisme', accent: '#AEDCC0' },
  { id: 'metal', nom: 'Serrurerie / métal', accent: '#B4BECC' },
  { id: 'neutre', nom: 'Neutre (gris clair)', accent: '#C6CBD3' },
];

export const docAcc = (soc) => {
  const dc = soc && soc.docCouleur;
  const accent =
    dc && dc[0] === '#' ? dc : (DOC_COULEURS.find((c) => c.id === dc) || {}).accent || DA;
  const accInk = _lumG(accent) > 0.55 ? _darkG(accent, 0.5) : accent;
  const accTxt = _lumG(accent) > 0.6 ? '#2A2A2A' : '#fff';
  return { accent, accInk, accTxt };
};

/** Palette d'identification visuelle des employés (badges, plannings, GPS). */
export const EMP_COLORS = [
  '#0E7490',
  '#6D28D9',
  '#B45309',
  '#0F6B3A',
  '#C0392B',
  '#1E2D4A',
  '#9D174D',
  '#0369A1',
];
